import { MatTableDataSource } from '@angular/material/table';
import { NoteProfile } from './noteProfile';
import { ModelCountyRecordFilterInput } from 'src/app/services/API.service';

export class Tab {
    id: string;
    userid: string;
    name: string;
    RecordKey: string;
    columns: string[] = [];
    headerTxt: string[] = [];
    pageSizeOptions: number[] = [];
    NoteProfile: NoteProfile;
    Exclude: string[] = [];
    data: MatTableDataSource<any>;
    dateRange = [];
    searchParms: ModelCountyRecordFilterInput[] = [];
    downloading = false;
    downloadErr = false;

    constructor(data: any) {
        this.id = data.id;
        this.userid = data.UserID;
        this.name = data.Title;
        this.RecordKey = data.RecordKey;

        data.Table.Columns.forEach(e => {
            this.columns.push(e.Field);
            this.headerTxt.push(e.HeaderTxt);
        });

        this.pageSizeOptions = data.Table.PageSizeOptions;

        this.NoteProfile = new NoteProfile(data.Note);

        this.Exclude = data.ExclusionList;
    }
}
